module.exports = __webpack_public_path__ + "static/img/inomph_logo.bd98567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/inomph_logo.png
// module id = W+Dh
// module chunks = 1